module.exports = __webpack_public_path__ + "assets/images/ert_hd.68a28173c743060f013a251b52fb67f5.png";